import { forwardRef, InputHTMLAttributes } from 'react';
import { UseFormRegisterReturn } from 'react-hook-form';

import { StyleType } from '~types/common';

import { S } from './style';

export type Size = 'lg' | 'md';

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  register?: UseFormRegisterReturn;
  label?: string;
  hasError?: boolean;
  errorMessage?: string;
  inputCss?: StyleType;
  labelCss?: StyleType;
  checkboxSize?: Size;
  isBorder?: boolean;
}

const CheckBox = forwardRef<HTMLInputElement, Props>(
  (
    {
      register,
      label,
      checkboxSize = 'lg',
      isBorder = true,
      hasError,
      errorMessage,
      inputCss,
      labelCss,
      ...props
    },
    ref,
  ) => {
    return (
      <S.CheckboxWrapper>
        <S.StyledCheckbox
          ref={ref}
          isBorder={isBorder}
          type='checkbox'
          {...props}
          {...register}
          id={props.id}
          inputCss={inputCss}
          checkboxSize={checkboxSize}
        />
        {label && (
          <S.CheckboxLabel htmlFor={props.id} labelCss={labelCss} checkboxSize={checkboxSize}>
            {label}
          </S.CheckboxLabel>
        )}
      </S.CheckboxWrapper>
    );
  },
);

CheckBox.displayName = 'CheckBox';

export default CheckBox;
